<template>
  <set-site-dialog
    ref="dialog"
    v-bind="$attrs"
    v-slot="slotProps"
    @quit="quit"
  >
    <q-select
      v-model="kitchenDisplay"
      data-test-id="kitchen-display-select"
      class="set-site-dialog-select q-mr-md q-my-sm full-width"
      label="Kitchen Display"
      bg-color="white"
      :options="kitchenDisplayOptions"
      option-label="name"
      map-options
      :disable="slotProps.loading"
      :read-only="!kitchenDisplayOptions.length"
      @update:model-value="setKitchenDisplay()"
    >
      <q-tooltip v-if="!kitchenDisplayOptions.length">
        No kitchen displays available for this site.
      </q-tooltip>
    </q-select>
  </set-site-dialog>
</template>

<script>

import { isElectronMode } from 'src/config'
import KdsClient from 'src/models/kds/KdsClient'
import SetSiteDialog from 'src/modules/global/components/SetSiteDialog'

export default {
  name: 'SetKitchenDisplayDialog',
  context: ['currentKdsClient'],
  configuration: ['kitchenDisplays'],
  components: {
    SetSiteDialog
  },
  data () {
    return {
      kitchenDisplay: null
    }
  },
  computed: {
    kitchenDisplayOptions () {
      if (!this.kitchenDisplays?.data) return []

      return _.filter(this.kitchenDisplays.data, 'isUnarchived')
    }
  },
  methods: {
    quit () {
      this.$quitKds()
    },
    async setKitchenDisplay () {
      try {
        this.$refs.dialog.loading = true

        let kdsClient
        if (this.currentKdsClient) {
          kdsClient = this.currentKdsClient
          kdsClient.kitchenDisplayId = this.kitchenDisplay.id
          kdsClient.isElectronMode = isElectronMode && !window.electronPrinter.status()?.error
        } else {
          kdsClient = new KdsClient({
            kitchenDisplayId: this.kitchenDisplay.id,
            isElectronMode: isElectronMode && !window.electronPrinter.status()?.error
          })
        }

        await kdsClient.save()
      } catch (exception) {
        this.$rollbar.error(`Failed to setKdsStation(), exception: ${exception.message}`)
      } finally {
        this.$refs.dialog.loading = false
        window.location.reload()
      }
    }
  }
}
</script>
